var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-box",class:_vm.stateChecker},[_c('base-svg',{attrs:{"name":_vm.stateChecker}}),_c('base-font',{staticClass:"info-text",attrs:{"marginReset":"","tag":"span","uppercase":"","size":"xs"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }